import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Button, Col, Row } from 'react-bootstrap';
import LargeCard from '../main/large-card';
import LeftSide from '../main/left-side';
import TitleCard from '../main/title-card';
import Postit from '../main/postit';
import ObjectAddressForm from './forms/object-address-form';
import ObjectInfoForm, { MULTI_FAMILY_HOUSE } from './forms/object-info-form';
import translate from '../translate';
import { MaybeLoadCountries } from '../../store/countriesDetailsSlice';
import { CreateMansion } from '../../store/mansionsSlice';
import { goToMansionOverview } from '../../nav/navigationService';
import MansionToOperationalContactAssignmentsForm from '../operational-contacts/mansion-to-operational-contact-assignments-form';
import { Formik } from 'formik';
import { PbRequest } from '../../store/pbRequest';
import { REQUEST_PENDING } from '../../store/network/managedRequest';

const defaultFields = {
    partner_id: '',
    mansion_type: MULTI_FAMILY_HOUSE,
    num_of_machines: '',
    housing_units: '',
    address: {
        street: '',
        housenumber: '',
        city: '',
        description: '',
        postalcode: '',
        country_id: 1,
    },
};

const CreateObject = createReactClass({
    displayName: 'CreateObject',

    propTypes: {
        strings: PropTypes.object,
        MaybeLoadCountries: PropTypes.func.isRequired,
        CreateMansion: PropTypes.func.isRequired,
        getOperationalContacts: PropTypes.object,
        createMansionRequestStatus: PropTypes.string.isRequired,
    },

    defaultProps: {
        title: ['Title', 'titley'],
        type: '',
        left: {
            content: null,
            title: null,
        },
        right: {
            content: null,
            title: null,
        },
    },

    getInitialState() {
        return { object: defaultFields };
    },

    componentDidMount() {
        this.props.MaybeLoadCountries();
    },

    getCards() {
        const objectCard = (
            <LargeCard type="card-edit" title={this.props.strings.address}>
                <ObjectAddressForm
                    forceValidation={this.state.forceValidation}
                    handleChange={this._handleWholeForm}
                />
            </LargeCard>
        );
        const objectInfoCard = (
            <LargeCard type="card-edit" title={this.props.strings.info}>
                <ObjectInfoForm
                    forceValidation={this.state.forceValidation}
                    handleChange={this._handleWholeForm}
                />
            </LargeCard>
        );
        return { objectCard, objectInfoCard };
    },

    _isValid() {
        if (this.state.object.id) {
            // if undefined, means nothing was changed, aka valid, otherwise, check if valid.
            return (
                this.state.isObjectFormValid === undefined ||
                this.state.isObjectFormValid
            );
        } else {
            return this.state.isObjectFormValid;
        }
    },

    _handleWholeForm(component) {
        if (component.country_id > 0) {
            const address = component;
            console.log('_handleObjectForm', address._valid);
            const valid = address._valid;
            const object = _.extend(this.state.object, {
                address: address,
            });
            delete object.address._valid;
            this.setState({ object: object, isObjectFormValid: valid });
        } else {
            const info = component;
            console.log('_handleObjectInfoForm');
            const object = _.extend(this.state.object, {
                mansion_type: info.mansion_type,
                num_of_machines: info.num_of_machines,
                housing_units: info.housing_units,
            });
            this.setState({ object: object });
        }
    },

    _onSubmit(values) {
        if (this._isValid()) {
            const object = this.state.object;
            delete object.partner_id;
            const mansionCreation = {
                ...object,
                operational_contact_ids: values.operationalContactIds,
            };
            this.props.CreateMansion(mansionCreation, () =>
                goToMansionOverview()
            );
        } else {
            this.setState({ forceValidation: true });
        }
    },

    maybeRenderOperationalContactsRow() {
        const operationalContacts = this.props.getOperationalContacts?.list;
        if (operationalContacts && operationalContacts.length > 0) {
            return (
                <Row>
                    <Col xs={8} sm={8} md={8} lg={8}>
                        <LargeCard
                            type="card-edit"
                            title={this.props.strings.operationalContactsTitle}
                        >
                            <MansionToOperationalContactAssignmentsForm
                                operationalContacts={operationalContacts}
                            />
                        </LargeCard>
                    </Col>
                </Row>
            );
        } else {
            return null;
        }
    },

    render() {
        const initialValues = {
            operationalContactIds: [],
        };
        const object = this.state.object;
        if (object) {
            const { objectCard, objectInfoCard } = this.getCards();
            return (
                <Formik initialValues={initialValues} onSubmit={this._onSubmit}>
                    {(formProps) => (
                        <Row>
                            <LeftSide>
                                <TitleCard
                                    title={[
                                        this.props.strings.add1,
                                        this.props.strings.add2,
                                    ]}
                                    left={{
                                        content: (
                                            <Link
                                                to="/objects"
                                                className="icon icon-wew-arrow-left icon-sm"
                                                data-testid="cancel-object-button"
                                            />
                                        ),
                                        title: this.props.strings.cancel,
                                    }}
                                />
                            </LeftSide>
                            <Col
                                xs={9}
                                sm={9}
                                md={9}
                                lg={9}
                                className="col-middle"
                            >
                                <Row>
                                    <Col xs={8} sm={8} md={8} lg={8}>
                                        {objectCard}
                                    </Col>
                                    <Col xs={4} sm={4} md={4} lg={4}>
                                        <Postit
                                            title={
                                                this.props.strings.Postit1.title
                                            }
                                        >
                                            {this.props.strings.Postit1.text1}
                                        </Postit>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={8} sm={8} md={8} lg={8}>
                                        {objectInfoCard}
                                    </Col>
                                    <Col xs={4} sm={4} md={4} lg={4}>
                                        <Postit
                                            title={
                                                this.props.strings.Postit2.title
                                            }
                                        >
                                            {this.props.strings.Postit2.text1}
                                        </Postit>
                                    </Col>
                                </Row>
                                {this.maybeRenderOperationalContactsRow()}
                                <Row className="spacer-tb">
                                    <Col xs={8} sm={8} md={8} lg={8}>
                                        <Button
                                            disabled={
                                                this.props
                                                    .createMansionRequestStatus ===
                                                REQUEST_PENDING
                                            }
                                            onClick={formProps.handleSubmit}
                                            className="btn btn-primary pull-right"
                                            data-testid="submit-form-button"
                                        >
                                            {this.props.strings.createObject}
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    )}
                </Formik>
            );
        } else {
            return <div />;
        }
    },
});

export default connect(
    (store) => ({
        getOperationalContacts: store.operationalContacts.operationalContacts,
        createMansionRequestStatus:
            store.pbRequest[PbRequest.CREATE_MANSION].status,
    }),
    { MaybeLoadCountries, CreateMansion }
)(translate('CreateObject')(CreateObject));
